export default function PasswordCheckIcon() {
  return (
    <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.8711 19.2502C13.5294 19.2502 13.2461 18.9668 13.2461 18.6252V3.2085C13.2461 2.86683 13.5294 2.5835 13.8711 2.5835C14.2127 2.5835 14.4961 2.86683 14.4961 3.2085V18.6252C14.4961 18.9668 14.2127 19.2502 13.8711 19.2502Z"
        fill="currentColor"
      />
      <path
        opacity="0.4"
        d="M5.0377 17.5833H11.7026V4.25H5.0377C3.107 4.25 1.54321 5.74167 1.54321 7.58333V14.25C1.54321 16.0917 3.107 17.5833 5.0377 17.5833ZM15.0843 17.5833H14.2107V4.25H15.0843C17.0151 4.25 18.5788 5.74167 18.5788 7.58333V14.25C18.5788 16.0917 17.0151 17.5833 15.0843 17.5833Z"
        fill="currentColor"
      />
      <path
        d="M5.52689 13.1399C5.38656 13.1399 5.24624 13.0882 5.13545 12.9774L4.02761 11.8696C3.92459 11.7653 3.86682 11.6247 3.86682 11.4781C3.86682 11.3316 3.92459 11.1909 4.02761 11.0867C4.24179 10.8725 4.5963 10.8725 4.81048 11.0867L5.52689 11.8031L8.44801 8.85449C8.66219 8.6403 9.0167 8.6403 9.23089 8.85449C9.44507 9.06867 9.44507 9.42318 9.23089 9.63736L5.91833 12.9774C5.80754 13.0882 5.66722 13.1399 5.52689 13.1399Z"
        fill="currentColor"
      />
    </svg>
  );
}
